var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-field input-field"},[_c('input',{class:_vm.textType,attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"autocomplete":_vm.autocomplete,"required":_vm.required},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }